module.exports = __webpack_public_path__ + "img/originalktape.4cd9b061.jpg";